import {
    GET_LOCALE_DISPLAY_NAME,
    SET_SPACE_LOCALIZATIONS,
    SET_CURRENT_LOCALE,
    LOAD_SPACE_LOCALIZATIONS,
    SET_PROPERTIES_MODULE_UI_DASHBOARD_CONTENT_DEFAULT,
    LOAD_SPACE_PROPERTY_UI_DASHBOARD_CONTENT_DEFAULT,
    SPACE_PROPERTY_UI_DASHBOARD_CONTENT_DEFAULT,
    SET_PROPERTIES_MODULE_UI_DASHBOARD_CONTENT_SORT_MAP,
    LOAD_SPACE_PROPERTY_UI_DASHBOARD_CONTENT_SORT_MAP,
    SPACE_PROPERTY_UI_DASHBOARD_CONTENT_SORT,
    GET_SPACE_PROPERTY_UI_DASHBOARD_CONTENT_SORT_MAP,
    SET_LOAD_PROPERTIES_STATE,
    LOAD_SPACE_PROPERTIES,
    LOADING_STARTED,
    LOADING_COMPLETED_SUCCESS,
    LOADING_COMPLETED_FAILURE,
} from "../services/constants"
import http from "../services/axios"
import {asyncArrayConstructor, asyncObjectConstructor} from "../services/helpers"

export const propertiesModule = {
    state: {
        loadPropertiesAsyncState: asyncArrayConstructor(),
        uiContentDashboardDefault: '',
        uiContentDashboardSortMap: null
    },
    getters: {
        [GET_SPACE_PROPERTY_UI_DASHBOARD_CONTENT_SORT_MAP]: (state) => {
            return state.uiContentDashboardSortMap
        }
    },
    mutations: {
        [SET_LOAD_PROPERTIES_STATE]: (state, newAsyncState) => {
            state.loadPropertiesAsyncState = newAsyncState
        },
        [SET_PROPERTIES_MODULE_UI_DASHBOARD_CONTENT_DEFAULT]: (state, newString) => {
            state.uiContentDashboardDefault = newString
        },
        [SET_PROPERTIES_MODULE_UI_DASHBOARD_CONTENT_SORT_MAP]: (state, newObj) => {
            state.uiContentDashboardSortMap = newObj
        }
    },
    actions: {
        async [LOAD_SPACE_PROPERTIES](context) {
            const newState = asyncArrayConstructor()
            newState.loadingState = LOADING_STARTED
            context.commit(SET_LOAD_PROPERTIES_STATE, newState)
            try {
                const proms = []
                proms.push(context.dispatch(LOAD_SPACE_PROPERTY_UI_DASHBOARD_CONTENT_DEFAULT))
                proms.push(context.dispatch(LOAD_SPACE_PROPERTY_UI_DASHBOARD_CONTENT_SORT_MAP))
                await Promise.all(proms)

                const newState = asyncArrayConstructor()
                newState.loadingState = LOADING_COMPLETED_SUCCESS
                context.commit(SET_LOAD_PROPERTIES_STATE, newState)
            } catch (e) {
                const newState = asyncArrayConstructor()
                newState.loadingState = LOADING_COMPLETED_FAILURE
                newState.error = e
                context.commit(SET_LOAD_PROPERTIES_STATE, newState)
            }
        },
        async [LOAD_SPACE_PROPERTY_UI_DASHBOARD_CONTENT_DEFAULT](context) {
            try {
                const results = await http.get(`api/management/spaces/${context.rootState.spaceMetadata.id}/properties/${SPACE_PROPERTY_UI_DASHBOARD_CONTENT_DEFAULT}`)
                if (results.data) {
                    if (results.data.value) {
                        context.commit(SET_PROPERTIES_MODULE_UI_DASHBOARD_CONTENT_DEFAULT, results.data.value)
                    }
                }
            } catch (e) {
                console.log(e)
            }
        },
        async [LOAD_SPACE_PROPERTY_UI_DASHBOARD_CONTENT_SORT_MAP](context) {
            try {
                const results = await http.get(`api/management/spaces/${context.rootState.spaceMetadata.id}/properties/${SPACE_PROPERTY_UI_DASHBOARD_CONTENT_SORT}`)
                if (results.data) {
                    if (results.data.value) {
                        const map = JSON.parse(results.data.value)
                        context.commit(SET_PROPERTIES_MODULE_UI_DASHBOARD_CONTENT_SORT_MAP, map)
                    }
                }
            } catch (e) {
                console.log(e)
            }
        },
    },
}
